import type { CenterStoneShape } from "../../shared/api-contract";

/** Minimal outline glyph per center-stone shape, self-hosted (no StoneAlgo
 * imagery) — a faceted-looking placeholder until Phase 6 generates real
 * snapshot thumbnails from our own renderer. */
export function ShapeIcon({ shape, size = 26 }: { shape: CenterStoneShape; size?: number }) {
  const common = { width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.4 };
  switch (shape) {
    case "round":
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /><path d="M3.5 12h17M12 3.5v17M6.3 6.3l11.4 11.4M17.7 6.3 6.3 17.7" strokeWidth="0.6" opacity={0.5} /></svg>;
    case "oval":
      return <svg {...common}><ellipse cx="12" cy="12" rx="6.5" ry="9" /></svg>;
    case "princess":
      return <svg {...common}><rect x="4" y="4" width="16" height="16" /><path d="M4 4l16 16M20 4 4 20" strokeWidth="0.6" opacity={0.5} /></svg>;
    case "emerald":
    case "radiant":
    case "radiant-elongated":
      return <svg {...common}><path d="M7 3.5h10L20.5 7v10L17 20.5H7L3.5 17V7z" /></svg>;
    case "cushion":
    case "cushion-elongated":
      return <svg {...common}><rect x="3.5" y="3.5" width="17" height="17" rx="6" /></svg>;
    case "pear":
      return <svg {...common}><path d="M12 3c3 3.2 6.5 6.8 6.5 11a6.5 6.5 0 1 1-13 0C5.5 9.8 9 6.2 12 3z" /></svg>;
    case "marquise":
      return <svg {...common}><path d="M12 3c4 3.5 7 6.9 7 9s-3 5.5-7 9c-4-3.5-7-6.9-7-9s3-5.5 7-9z" /></svg>;
    case "asscher":
      return <svg {...common}><path d="M8 3.5h8L20.5 8v8L16 20.5H8L3.5 16V8z" /></svg>;
    case "heart":
      return <svg {...common}><path d="M12 20s-7.5-4.7-7.5-10A4.5 4.5 0 0 1 12 7a4.5 4.5 0 0 1 7.5 3c0 5.3-7.5 10-7.5 10z" /></svg>;
    default:
      return <svg {...common}><circle cx="12" cy="12" r="8.5" /></svg>;
  }
}
